module.exports = __webpack_public_path__ + "static/media/portfolio10.35599e9f.jpg";